"use client";

import "./styles.css";

function Terms() {
  return (
    <div className="style-0">
      <div className="style-1">
        <div className="style-2">
          <div className="style-3">
            <h4 className="style-4">Termos de Uso</h4>
            <h4 className="style-5">1. INTRODUÇÃO</h4>
            <div className="style-6">
              Estes termos de uso descrevem as regras de uso que se aplicam aos USUÁRIOS, que acessam e
              utilizam as funcionalidades e serviços do site Yinflow.Life (disponível em{" "}
              <a href="https://yinflow.life/" className="style-7">
                https://yinflow.life/
              </a>
              ), de propriedade da YINFLOW LTDA, pessoa jurídica de Direito Privado, inscrita no CNPJ sob o nº
              42.516.954/0001-00, estabelecida na Avenida Brigadeiro Faria Lima, nº 2369, Conj. 1102 - Bairro:
              Jardim Paulistano, São Paulo/SP - CEP 01452922, e demais instituições afiliadas, parceiras e
              coligadas, que também se comprometem a aderir a estes termos de uso e à{" "}
              <span className="style-7">Política de Privacidade</span> da YINFLOW LTDA.
              <br className="style-8" />
              <br className="style-9" />
              Este Termo de Uso está em consonância com a nossa{" "}
              <span className="style-10">Política de Privacidade</span>, elaborada em conformidade com a Lei
              Federal nº 12.965, de 23 de abril de 2014 (Marco Civil da Internet) e a Lei Federal nº 13.709,
              de 14 de agosto de 2018 (Lei de Proteção de Dados Pessoais).
            </div>
            <h4 className="style-11">2. Condições para Utilizar e Acessar Nossos Serviços</h4>
            <div className="style-12">
              <strong className="style-13">2.1.</strong> Para utilizar e acessar nossos serviços você precisa,
              necessariamente:
            </div>
            <ul role="list" className="style-14">
              <li className="style-15">
                <div className="style-16">
                  ser maior de 18 anos, ou estar devidamente representado e/ou assistido e ter poderes para
                  cumprir com as obrigações aqui previstas;
                </div>
              </li>
              <li className="style-17">
                <div className="style-18">aceitar a nossa Política de Privacidade;</div>
              </li>
              <li className="style-19">
                <div className="style-20">
                  ter ciência de que seus dados serão trafegados, com a devida cautela, entre várias
                  plataformas e servidores; e
                </div>
              </li>
              <li className="style-21">
                <div className="style-22">aceitar os presentes Termos de Uso.</div>
              </li>
            </ul>
            <div className="style-23">
              <strong className="style-24">2.2.</strong> Dito isso, ao acessar este site, consideramos que
              você é agente capaz e está agindo na plenitude da boa-fé, se comprometendo a utilizar o site
              conforme os termos de uso aqui descritos. Não continue a usar os serviços Yinflow.Life caso você
              discorde dos termos e condições deste contrato.
            </div>
            <div className="style-25">
              <strong className="style-26">2.3.</strong> O uso do site está condicionado à aceitação de todas
              as condições aqui estabelecidas. Ao aderir ao uso do site Yinflow.Life, o usuário:
            </div>
            <ul role="list" className="style-27">
              <li className="style-28">
                <div className="style-29">
                  Consente com o tratamento de dados pessoais conforme estes termos e a nossa{" "}
                  <span className="style-30">Política de Privacidade</span>;
                </div>
              </li>
              <li className="style-31">
                <div className="style-32">
                  Confirma a veracidade das informações fornecidas no cadastro quando o fizer; e
                </div>
              </li>
              <li className="style-33">
                <div className="style-34">
                  Autoriza o recebimento de mensagens do sistema sobre interrupções técnicas, atualizações dos
                  Termos de Uso, novas funcionalidades, informações de marketing, solicitações de avaliações,
                  confirmação de agendamentos e outras comunicações similares.
                </div>
              </li>
            </ul>
            <div className="style-35">
              <strong className="style-36">2.4.</strong> Para utilizar os serviços, o usuário deve atender às
              seguintes condições técnicas:
            </div>
            <ul role="list" className="style-37">
              <li className="style-38">
                <div className="style-39">Possuir acesso à Internet; e</div>
              </li>
              <li className="style-40">
                <div className="style-41">
                  Utilizar um dos seguintes navegadores atualizados: Firefox, Chrome, Safari, Internet
                  Explorer ou Opera.
                </div>
              </li>
            </ul>
            <div className="style-42">
              <strong className="style-43">2.5. </strong>Os usuários se comprometem a usar os conteúdos e
              serviços oferecidos por Yinflow.Life de forma legal e ética, abstendo-se de:
            </div>
            <ul role="list" className="style-44">
              <li className="style-45">
                <div className="style-46">
                  Disseminar conteúdos ilegais, violentos, pornográficos, racistas, ofensivos, ou que incitem
                  crimes.
                </div>
              </li>
              <li className="style-47">
                <div className="style-48">
                  Introduzir vírus ou executar ações que possam comprometer a integridade de sistemas
                  eletrônicos.
                </div>
              </li>
              <li className="style-49">
                <div className="style-50">
                  Acessar contas de e-mail de outros usuários ou áreas restritas dos sistemas de Yinflow.Life
                  ou terceiros.
                </div>
              </li>
              <li className="style-51">
                <div className="style-52">
                  Violar direitos de propriedade intelectual ou confidencialidade de informações.
                </div>
              </li>
              <li className="style-53">
                <div className="style-54">
                  Reproduzir, copiar, distribuir ou modificar conteúdo sem a devida autorização.
                </div>
              </li>
              <li className="style-55">
                <div className="style-56">Coletar dados para fins publicitários não autorizados.</div>
              </li>
            </ul>
            <h4 className="style-57">3. Esclarecimentos Preliminares</h4>
            <div className="style-58">
              Para facilitar a sua experiência e proporcionar um atendimento de excelência, essa plataforma
              tem como missão fundamental conectar pacientes e profissionais da saúde por meio desta
              plataforma proprietária (Yinflow.Life), na qual utilizamos uma integração de tecnologias
              virtuais para agendamento, gestão de dados de saúde e teleatendimento via tecnologia digital de
              vídeo e/ou presencial conforme a oportunidade e conveniência dos médicos, profissionais da saúde
              e pacientes.
            </div>
            <h4 className="style-59">
              4. Se Você é um Paciente (Usuário não Profissional da Saúde que Utiliza a Nossa Plataforma)
            </h4>
            <div className="style-60">
              <strong className="style-61">4.1.</strong> Se você é um paciente, ou um usuário de nossa
              plataforma em busca de informações de um profissional de saúde para agendamento de consultas
              médicas e sessões de terapia, informamos que os propósitos de tratamento e uso de seus dados
              estão especificados em nossa <span className="style-62">Política de Privacidade</span>.
              <br className="style-63" />
              <br className="style-64" />
              <strong className="style-65">4.2.</strong> Quando você agenda uma consulta médica ou sessão de
              consulta em nossa plataforma, seus dados pessoais são processados e compartilhados conforme
              especificado na nossa <span className="style-66">Política de Privacidade</span>.
              <br className="style-67" />
              <br className="style-68" />
              <strong className="style-69">4.3.</strong> Ao usar nossa plataforma, você estará sujeito aos
              termos especificados em nossa <span className="style-70">Política de Privacidade</span> durante
              o agendamento e participação em consultas. Ao utilizar canais de comunicação direta com
              profissionais de saúde, como e-mail, WhatsApp e telefone/celular dos mesmos, a privacidade
              destes dados se dará com base na política de privacidade do profissional de saúde.
            </div>
            <h4 className="style-71">5. Comentários e Depoimentos dos Usuários</h4>
            <div className="style-72">
              <strong className="style-73">5.1.</strong> Você poderá ter o direito de postar comentários e
              depoimentos de suas experiências enquanto usuário dos serviços em nosso site e tem todas as
              licenças e consentimentos para tal. Contudo, saiba que você é responsável por tais comentários.
              Tenha ciência de que seus comentários não devem invadir qualquer propriedade intelectual,
              incluindo direitos morais, autorais, patentes ou marcas registradas de terceiros.
              <br className="style-74" />
              <br className="style-75" />
              <strong className="style-76">5.2. </strong>Seus comentários não devem conter material
              difamatório, injurioso, ofensivo, indecente ou de alguma forma ilícito, ou que invada a
              privacidade.
              <br className="style-77" />
              <br className="style-78" />
              <strong className="style-79">5.3. </strong>Seus comentários não serão usados para solicitar ou
              promover negócios, tampouco apresentar atividades comerciais ou atividades ilícitas.
              <br className="style-80" />
              <br className="style-81" />
              <strong className="style-82">5.4.</strong> Você, por meio deste termo de consentimento, concede
              à Yinflow.Life a licença não exclusiva de usar, reproduzir, moderar e autorizar outros a usar,
              reproduzir e moderar qualquer um de seus comentários em qualquer forma, formato ou mídia.
            </div>
            <h4 className="style-83">6. Exclusão de Garantias e Responsabilidade</h4>
            <div className="style-84">
              <strong className="style-85">6.1.</strong> O conteúdo do site é meramente informativo e não
              garante a completude, veracidade ou utilidade das informações para um propósito específico.
              <br className="style-86" />
              <br className="style-87" />
              <strong className="style-88">6.2.</strong> Yinflow.Life não se responsabiliza por:
            </div>
            <ul role="list" className="style-89">
              <li className="style-90">
                <div className="style-91">
                  Impossibilidade de acesso ao site ou falta de precisão dos conteúdos.
                </div>
              </li>
              <li className="style-92">
                <div className="style-93">Presença de vírus ou outros elementos nos conteúdos.</div>
              </li>
              <li className="style-94">
                <div className="style-95">
                  Decorrência de ações ilegais ou quebra de termos deste documento.
                </div>
              </li>
            </ul>
            <div className="style-96">
              <strong className="style-97">6.3.</strong> Links em nosso site são apenas informativos, e
              Yinflow.Life não se responsabiliza pela operação ou acessibilidade de sites vinculados.
              <br className="style-98" />
              <br className="style-99" />
              <strong className="style-100">6.4.</strong> O uso seguro e correto do site é de responsabilidade
              exclusiva do usuário, incluindo a manutenção de seus dispositivos de acesso e a segurança de
              suas credenciais.
            </div>
            <h4 className="style-101">7. Proteção de Dados</h4>
            <div className="style-102">
              O fornecimento de dados pessoais e imagens dos usuários é necessário para o funcionamento dos
              serviços da plataforma. Yinflow.Life protege essas informações e garante que os usuários podem
              corrigir, editar e complementar seus dados.
              <br className="style-103" />
              <br className="style-104" />
              Para mais detalhes, consulte a <span className="style-105">Política de Privacidade</span>.
            </div>
            <h4 className="style-106">8. Procedimento em Caso de Atividades Ilícitas</h4>
            <div className="style-107">
              Caso algum usuário ou terceiro identifique atividades ilegais ou uso impróprio de conteúdo nas
              páginas da web vinculadas ao site, deve informar Yinflow.Life, detalhando as supostas violações.
            </div>
            <h4 className="style-108">9. LINKS</h4>
            <div className="style-109">
              A Yinflow.life não analisou todos os sites vinculados ao seu site e não é responsável pelo
              conteúdo de nenhum site vinculado. A inclusão de qualquer link não implica endosso por
              Yinflow.life do site. O uso de qualquer site vinculado é por conta e risco do usuário.
            </div>
            <h4 className="style-110">10. MODIFICAÇÕES</h4>
            <div className="style-111">
              O Yinflow.life pode revisar estes termos de serviço do site a qualquer momento, sem aviso
              prévio. Ao usar este site, você concorda em ficar vinculado à versão atual desses termos de
              serviço.
            </div>
            <h4 className="style-112">11. ISENÇÃO DE RESPONSABILIDADE</h4>
            <div className="style-113">
              <strong className="style-114">8.1</strong> Os materiais no site da{" "}
              <a href="/discover" className="style-115">
                Yinflow.Life
              </a>{" "}
              acerca de seus serivços e de parceiros são fornecidos 'como estão'. Yinflow.life não oferece
              garantias, expressas ou implícitas, e, por este meio, isenta e nega todas as outras garantias,
              incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um
              fim específico ou não violação de propriedade intelectual ou outra violação de direitos.
              <br className="style-116" />
              <br className="style-117" />
              <strong className="style-118">8.2</strong> Além disso, a{" "}
              <a href="/discover" className="style-119">
                Yinflow.life
              </a>{" "}
              não garante ou faz qualquer representação relativa à precisão, aos resultados prováveis ou à
              confiabilidade do uso dos serviços exibidos em seu site, sejam próprios ou de terceiros, ou de
              outra forma vinculados a este site.
            </div>
            <h4 className="style-120">12. LEI APLICÁVEL</h4>
            <div className="style-121">
              Os presentes Termos de Uso serão regidos pela legislação brasileira vigente, e as comunicações
              ocorrerão em português.
            </div>
            <h4 className="style-122">13. SUPORTE</h4>
            <div className="style-123">
              Em caso de problemas ou dificuldades durante o uso do site, o usuário deve contatar o suporte da
              Yinflow.Life através do e-mail{" "}
              <a href="[mailto:suporte@yinflow.life](mailto:suporte@yinflow.life)" className="style-124">
                suporte@yinflow.life
              </a>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
